import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
        FETCH_RTO_DETAILS
        FETCH_RTO_DETAILS_SUCCESS
        FETCH_RTO_DETAILS_FAILURE
        UPDATE_SSR_STATUS
        SET_POPULAR_CITY_DETAILS
        SET_VAS_DETAILS
        FETCH_RTO_BLOGS_SUCCESS
        FETCH_RTO_BLOGS_FAILURE
        SET_QUESTIONS
        SET_BANNER_LIST
`,
    {
        prefix: "rtoinfo/"
    }
);
